module.exports = __webpack_public_path__ + "img/beautify10.bdcb1241.webp";